/**
 * L-036: Help is the LMS form. MFEs live on apps.learn.* so the href
 * must be LMS-absolute. Nested chrome (sub-brand, footer Learn) is what
 * actually renders — not helpUrl alone. Stale saved BSG_CHROME can still
 * carry /support from L-033; rewrite it here. Do not touch donor URLs.
 */

export const HELP_PATH = "/help/";

const STALE_HELP_PATHS = new Set(["/support", "/support/", "/help", "/help/"]);
const LMS_HOST = "learn.brainandspinegroup.org";
const MFE_HOST = "apps.learn.brainandspinegroup.org";

export function helpFormUrl(lmsBaseUrl, fallbackLearnUrl) {
  const lms = String(lmsBaseUrl || fallbackLearnUrl || "").replace(/\/$/, "");
  if (lms) return `${lms}${HELP_PATH}`;
  return HELP_PATH;
}

export function isHelpItem(item) {
  if (!item || typeof item !== "object") return false;
  const key = String(item.key || "").trim().toLowerCase();
  const label = String(item.label || item.title || "").trim().toLowerCase();
  return key === "help" || label === "help";
}

export function isStaleHelpHref(href) {
  const value = String(href || "").trim();
  if (!value) return false;
  if (STALE_HELP_PATHS.has(value)) return true;
  try {
    const url = new URL(value);
    const path = url.pathname.replace(/\/+$/, "") || "/";
    if (path !== "/support" && path !== "/help") return false;
    return url.hostname === LMS_HOST || url.hostname === MFE_HOST;
  } catch {
    return false;
  }
}

export function rewriteHelpChrome(chrome, helpUrl) {
  const next = chrome && typeof chrome === "object" ? chrome : {};
  next.helpUrl = helpUrl;
  if (Array.isArray(next.subbrandItems)) {
    next.subbrandItems = next.subbrandItems.map((item) => {
      if (isHelpItem(item) || isStaleHelpHref(item.href)) {
        return { ...item, href: helpUrl };
      }
      return item;
    });
  }
  if (Array.isArray(next.footerColumns)) {
    next.footerColumns = next.footerColumns.map((col) => ({
      ...col,
      links: (col.links || []).map((link) => {
        if (isHelpItem(link) || isStaleHelpHref(link.url)) {
          return { ...link, url: helpUrl };
        }
        return link;
      }),
    }));
  }
  return next;
}